// react_frontend/src/Components/Modules/Error500.js
import React from 'react'
import Breadcrumb from '../Partials/Breadcrumb'

const Error500 = () => {
    return (
        <>
            <Breadcrumb title={'Error 500'} />
            <div className="row justify-content-center">
                <div className="col-md-4">
                    <h1 className='text-danger'> Something is going on!  </h1>
                </div>
            </div>
        </>
    )
}

export default Error500